import React from 'react';
import { Box, Typography } from '@mui/material';

import DateTimeText from '../../../../../../shared/DateTimeText';
import { Status } from '../../../../../adminDashboard/components/dashboardBody/components';
import Loading from '../loading';
import useStyles from '../../styles';

const DataItem = ({ appInst, displayObj }) => {
    const classes = useStyles();

    const displayType = () => {
        switch (displayObj.type) {
            case 'date':
                return <DateTimeText date={appInst[displayObj.key]} />;
            case 'status':
                return (
                    <Status
                        statusId={appInst[displayObj.key]}
                        displayLastUpdated={false}
                        styleOverride={{ fontSize: '16px', circleSize: '10px' }}
                    />
                );
            case 'loading':
                return <Loading />;
            default:
                return <Typography>{appInst[displayObj.key]}</Typography>;
        }
    };

    return (
        <Box key={`app-${appInst.ID}-data-${displayObj.key}`}>
            <Typography className={classes.dataTitle}>{displayObj?.label ? displayObj.label : <Loading />}</Typography>

            <Box className={classes.dataContainer}>{displayType()}</Box>
        </Box>
    );
};

export default DataItem;
